import { useNavigation, useRootNavigation } from "expo-router";

const useCanGoBack = () => {
  const rootNavigation = useRootNavigation();
  const localNavigation = useNavigation();

  const canGoBack = localNavigation.canGoBack() || rootNavigation?.canGoBack();

  return canGoBack;
};

export default useCanGoBack;
